import Vue from 'vue'
import App from './App.vue'
import { router } from '@/router/router'
import { routerHome } from '@/router/routerHome'
import { store } from '@/store'
import modal from 'vue-js-modal'
import axios from 'axios'
Vue.use(modal, {dialog: true})

Vue.config.productionTip = false

const host = window.location.host;
const parts = host.split('.');
const domainLength = 3;

const routerMain = () => {
  let route;

  if(parts[0] === 'onsalehome' || parts[0] === 'stgonsalehome') {
    route = routerHome;
  } else {
    route = router;
  }
  return route;
};

new Vue({
  router : routerMain(),
  store,
  axios,
  render: h => h(App)
}).$mount('#app')


